import * as React from "react";

export class HeadingTitle extends React.PureComponent<{
    name: string,
    eventsCount: string
}, {}> {

    render() {
        return (
            <div className="rj-ev-list__heading-title" data-uat="div-ev-list-heading-title">
                <span className="rj-ev-list__heading-title__content rj-ev-list__heading-title__name" data-uat="span-ev-list-heading-title-name">
                    {this.props.name}
                    <span className="rj-ev-list__heading-title__content rj-ev-list__heading-title__count" data-uat="span-ev-list-heading-title-count">{this.props.eventsCount}</span>
                </span>
            </div>
        )
    }
}